import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from '../../components/ThemeToggle';
import panicButtonImage from '../../images/bt_panic_aberto.png';

const PanicButtonIntro = () => {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Detectar dark mode
    const checkDarkMode = () => {
      const isDark = document.body.classList.contains('dark-mode');
      setIsDarkMode(isDark);
    };

    // Detectar mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Verificar inicialmente
    checkDarkMode();
    checkMobile();

    // Observer para mudanças na classe do body
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Listener para mudanças de tamanho da tela
    const handleResize = () => checkMobile();
    window.addEventListener('resize', handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleStart = () => {
    navigate('/panic-button/step1');
  };

  const containerStyles = {
    minHeight: '100vh',
    padding: '20px',
    background: '#000000',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
    color: '#ffffff',
    position: 'relative'
  };

  const cardStyles = {
    background: isMobile ? 'transparent' : 'rgba(255, 255, 255, 0.1)',
    backdropFilter: isMobile ? 'none' : 'blur(20px)',
    borderRadius: isMobile ? '0' : '25px',
    padding: isMobile ? '0' : (isMobile ? '2rem' : '3rem'),
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
    boxShadow: isMobile ? 'none' : '0 20px 60px rgba(0, 0, 0, 0.4)',
    border: isMobile ? 'none' : '1px solid rgba(255, 255, 255, 0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  };

  const imageStyles = {
    width: '100%',
    maxWidth: isMobile ? '250px' : '300px',
    height: 'auto',
    borderRadius: '15px',
    boxShadow: isMobile ? 'none' : '0 10px 30px rgba(0, 0, 0, 0.5)',
    transition: 'transform 0.3s ease',
    cursor: 'pointer'
  };

  const imageHoverStyles = {
    transform: 'scale(1.05)',
    boxShadow: isMobile ? 'none' : '0 15px 40px rgba(0, 0, 0, 0.7)'
  };

  return (
    <div style={containerStyles}>
      <ThemeToggle />
      
      <div style={cardStyles}>
        <img 
          src={panicButtonImage} 
          alt="Botão do Pânico" 
          style={imageStyles}
          onClick={handleStart}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, imageHoverStyles);
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = isMobile ? 'none' : '0 10px 30px rgba(0, 0, 0, 0.5)';
          }}
          onError={(e) => {
            // Fallback caso a imagem não carregue
            e.target.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
};

export default PanicButtonIntro;